// Lista de Cargos para Pessoa de Contacto - conforme documento ENTRAJUDA 2º Steering 2026
// Usado em: PortalRegistarPage.jsx, InstituicoesPage.jsx

export const CARGOS_CONTACTO = [
  'Administrativo',
  'Coordenador',
  'Diretor Geral',
  'Diretor Técnico',
  'Educador',
  'Membro da Direção/Administração',
  'Membro dos Órgãos Sociais',
  'Presidente',
  'Provedor',
  'Secretário-Geral',
  'Técnico Serviço Social',
  'Técnicos',
  'Voluntário',
  'Outro'
];

// Tipos de Entidade conforme documento ENTRAJUDA 3º Steering 2026
export const TIPOS_ENTIDADE = [
  'Associação de Pais',
  'Associação Solidariedade Social',
  'Autarquia',
  'Bibliotecas, Estab. Prisionais, Bombeiros e Hospitais',
  'Cáritas',
  'Casa do Povo',
  'Centros Sociais, Paroquiais e Comunitários',
  'Conferência Vicentina',
  'Congregações e Comunidades Religiosas',
  'Cooperativa',
  'Cruz Vermelha Portuguesa',
  'Empresa',
  'Entidade Governamental',
  'Escola',
  'Escuteiros',
  'Fundação',
  'Instituto',
  'Misericórdia',
  'Mutualista',
  'ONG/ONGD',
  'Outros',
  'Proteção dos Animais'
];

// Estados da Instituição com cores
export const ESTADOS_INSTITUICAO = {
  'Acordo': { cor: 'green', label: 'Acordo' },
  'Ativo': { cor: 'green', label: 'Ativo' },
  'Candidato': { cor: 'yellow', label: 'Candidato' },
  'Inativo': { cor: 'red', label: 'Inativo' },
  'Suspenso': { cor: 'red', label: 'Suspenso' },
  'Sem Acordo': { cor: 'green', label: 'Sem Acordo' },
  'Sem Relação': { cor: 'yellow', label: 'Sem Relação' },
  'Potencial': { cor: 'blue', label: 'Potencial' },
  'Pendente Ativação': { cor: 'purple', label: 'Pendente Ativação' }
};

// Prioridades de atendimento
export const PRIORIDADES_ATENDIMENTO = [
  'Crítica',
  'Muito Alta',
  'Alta',
  'Média-Alta',
  'Média',
  'Média-Baixa',
  'Baixa',
  'Muito Baixa'
];

// Origens da Instituição
export const ORIGENS_INSTITUICAO = [
  'Banco Alimentar',
  'Cons. Central Vicentinas',
  'Dar e Receber',
  'ENTRAJUDA',
  'Outras',
  'PCAAC',
  'Parceiro EA',
  'União Misericórdias',
  'Candidatura Portal'
];
